import { makeAutoObservable } from 'mobx';
import { AuthStore, authStore } from './AuthStore';
import { ToastStore, toastStore } from './ToastStore';
import { PartnersStore, partnersStore } from './PartnersStore';

export class RootStore {
  authStore: AuthStore;
  toastStore: ToastStore;
  partnersStore: PartnersStore;

  constructor() {
    this.authStore = authStore;
    this.toastStore = toastStore;
    this.partnersStore = partnersStore;
    makeAutoObservable(this);
  }
}

export const rootStore = new RootStore();
